export default "__VITE_ASSET__BjYFopdQ__"